import React, { useEffect, useState } from 'react'
import { fetchLinkPreview } from '@store/actions'
import { useAppDispatch } from '@store/hooks'
import { extractUrlsFromHTML } from '@utils/chat.util'
import { sanitizeRichTextHtml } from '@utils/sanitize-html.util'
import { logger } from '@utils/safeLogger'

import './ContentPreviewStyle.css'

interface ContentPreviewProps {
  htmlContent: string
}

const ContentPreview: React.FC<ContentPreviewProps> = ({ htmlContent }) => {
  const dispatch = useAppDispatch()
  const [image, setImage] = useState<string>('')
  const [url, setUrl] = useState<string>('')

  useEffect(() => {
    const loadLinkPreviews = async (): Promise<void> => {
      if (!htmlContent) {
        setImage('')
        setUrl('')
        return
      }

      try {
        // Extract URLs from HTML content
        const urls = extractUrlsFromHTML(htmlContent)

        if (urls.length === 0) {
          setImage('')
          setUrl('')
          return
        }

        const preview = await dispatch(fetchLinkPreview(urls[0])).unwrap()
        const imageUrl = preview?.image || ''
        const linkUrl = preview?.url || ''
        setImage(imageUrl)
        setUrl(linkUrl)
      } catch (err) {
        logger.error('Error loading link previews:', err)
        setImage('')
        setUrl('')
      }
    }

    // Debounce the API call
    const timeoutId = setTimeout(() => {
      loadLinkPreviews()
    }, 300)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [htmlContent])
  const handleClick = (e: React.MouseEvent): void => {
    e.preventDefault()
    e.stopPropagation()
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      <div className="chat-content">
        {image && url && (
          <div className="link-previews-container">
            <div className="link-preview-container" onClick={handleClick}>
              <div className="link-preview-image-wrapper">
                <img src={image} alt={url} className="link-preview-image" />
              </div>
            </div>
          </div>
        )}
        <div
          className="custom-chat-format"
          dangerouslySetInnerHTML={{
            __html: sanitizeRichTextHtml(htmlContent),
          }}
        />
      </div>
    </>
  )
}

export default ContentPreview
